export class Kramer {
    constructor(socket, log) {
        this.socket = socket;
        this.firmwareVersion = '3.00.0';
        this.videoOutputs = Array(17).fill('1');
        this.modelTable = {
            '-L8YzD_lQCyddT8T4__k': 'VP-778',
            '-L9BWZjCtA5wohoLrq9Z': 'VP-558',
            '-LTwPOKHIesIXzoezjD3': 'VP-445',
            '-LbxHa_WeKISTdApmweq': 'VS-622DT',
            '-M8fG-uJkWQsRogMZ4OD': 'VS-44H2A',
            '-MKKz6UL1S6S1ngVv0lb': 'VP-774A',
            '-ML9TX7ITE-hJ5quZV0L': 'VP-773A',
        };
        this.modelName = 'VP-778';
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /#VERSION\?/i,
                callback: (match) => {
                    this.socket.send(`~01@VERSION ${this.firmwareVersion}`);
                },
            },
            {
                name: 'getRoute',
                regExp: /#ROUTE\?\s+(\d+),(\d+)/i,
                callback: (match) => {
                    if (match[2]) {
                        const output = parseInt(match[2], 10);
                        this.socket.send(`~01@ROUTE ${match[1]},${match[2]},${this.videoOutputs[output]}`);
                    }
                    else {
                        this.socket.send(`ERR`);
                    }
                },
            },
            {
                name: 'getVideo',
                regExp: /#VID\?\s+(\d+)/i,
                callback: (match) => {
                    if (match[1]) {
                        const output = parseInt(match[1], 10);
                        this.socket.send(`~01@VID ${this.videoOutputs[output]}>${match[1]}`);
                    }
                    else {
                        this.socket.send(`ERR`);
                    }
                },
            },
            {
                name: 'getYcommandVideo',
                // Last zero is for the main window
                regExp: /Y\s+\d[\s,]120(:?,[0|1])?$/i,
                callback: (match) => {
                    this.socket.send(`~01@Y 1,120,${this.videoOutputs[0]}`);
                },
            },
            {
                name: 'model',
                regExp: /#MODEL\?/i,
                callback: (match) => {
                    this.socket.send(`~01@MODEL ${this.modelName}`);
                },
            },
            {
                name: 'setRoute',
                regExp: /#ROUTE\s+(\d+),(\d+),(\d+)/i,
                callback: (match) => {
                    if (match[2]) {
                        const output = parseInt(match[2], 10);
                        this.videoOutputs[output] = match[3];
                        this.socket.send(`~01@ROUTE ${match[1]},${match[2]},${match[3]}`);
                    }
                    else {
                        this.socket.send(`ERR`);
                    }
                },
            },
            {
                name: 'setVideo',
                regExp: /#VID\s+(\d+)>(\d+)/i,
                callback: (match) => {
                    if (match[1] && match[2]) {
                        const output = parseInt(match[2], 10);
                        this.videoOutputs[output] = match[1];
                        this.socket.send(`~01@VID ${match[2]}>${match[1]}`);
                    }
                    else {
                        this.socket.send(`ERR`);
                    }
                },
            },
            {
                name: 'setYcommandVideo',
                regExp: /Y\s+\d+[\s,]120[\s,](\d+)/i,
                callback: (match) => {
                    if (match[1]) {
                        // only one output on the VP-774A
                        this.videoOutputs[0] = match[1];
                        this.socket.send(`~01@Y 0,120,${match[1]}`);
                    }
                    else {
                        this.socket.send(`ERR`);
                    }
                },
            },
            {
                name: 'status',
                regExp: /#$/i,
                callback: (match) => {
                    this.socket.send(`~01@ OK`);
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`ERR`);
                },
            },
        ];
    }
    onConfigure(config) {
        var _a;
        this.modelName = this.modelTable[(_a = config === null || config === void 0 ? void 0 : config.modelNumber) !== null && _a !== void 0 ? _a : '-L8YzD_lQCyddT8T4__k'];
    }
}
Kramer.emulatorType = 'socketEmulator';
Kramer.key = '-L8YyugCsWnrjhcTC957';
